/**
 * @generated SignedSource<<9dce48f562c9ed8f4fdc991b1fc1b5d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FeedEmailMessageQuery$variables = {
  id: string;
};
export type FeedEmailMessageQuery$data = {
  readonly message: {
    readonly body?: string | null;
    readonly id?: string;
  } | null;
};
export type FeedEmailMessageQuery = {
  response: FeedEmailMessageQuery$data;
  variables: FeedEmailMessageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedEmailMessageQuery",
    "selections": [
      {
        "alias": "message",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "type": "EmailMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedEmailMessageQuery",
    "selections": [
      {
        "alias": "message",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "EmailMessage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b989fe4e66da060c59a9d8f6f84c7580",
    "id": null,
    "metadata": {},
    "name": "FeedEmailMessageQuery",
    "operationKind": "query",
    "text": "query FeedEmailMessageQuery(\n  $id: ID!\n) {\n  message: node(id: $id) {\n    __typename\n    ... on EmailMessage {\n      id\n      body\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d2a7862e59c97bfd8d63d1ad80654ac7";

export default node;
